export const GET_CALENDAR_DATA_REQUEST = "GET_CALENDAR_DATA_REQUEST"
export const GET_CALENDAR_DATA_SUCCESS = "GET_CALENDAR_DATA_SUCCESS"
export const GET_CALENDAR_DATA_FAILURE = "GET_CALENDAR_DATA_FAILURE"
